const ReconciliationType = {
  AUTO: 'auto',
  MANUAL: 'manual',
  PENDING: 'pending',
};

module.exports = ReconciliationType;
